module.exports = __webpack_public_path__ + "static/img/new_program_04.4ca726c4.jpg";